"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOtpHandlerRequestStatus = void 0;
/**
 * Статусы запроса (request) в otp-handler
 */
var EOtpHandlerRequestStatus;
(function (EOtpHandlerRequestStatus) {
    /**
     * В процессе
     */
    EOtpHandlerRequestStatus["wait"] = "wait";
    /**
     * Канал в request уже сменился, вызовите getChannel
     */
    EOtpHandlerRequestStatus["channelChanged"] = "channelChanged";
    /**
     * Request ждёт перезапуска канала, вызовите resend
     */
    EOtpHandlerRequestStatus["resendChannel"] = "resendChannel";
    /**
     * Нет подходяищих каналов для продолжения запроса
     * При этой ошибке request закрывается
     */
    EOtpHandlerRequestStatus["noAvailableChannels"] = "noAvailableChannels";
    /**
     * Превышенно кол-во попыток ввода кода
     * При этой ошибке request закрывается
     */
    EOtpHandlerRequestStatus["attemptsExpired"] = "attemptsExpired";
    /**
     * Успешное завершение
     */
    EOtpHandlerRequestStatus["confirmed"] = "confirmed";
    /**
     * Принудительное закрытие
     */
    EOtpHandlerRequestStatus["closed"] = "closed";
})(EOtpHandlerRequestStatus || (exports.EOtpHandlerRequestStatus = EOtpHandlerRequestStatus = {}));
//# sourceMappingURL=OtpHandlerRequestStatus.enum.js.map